import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getEligibleBinCount = {
  name: "getEligibleBinCount" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ eligibleBinCount: z.number().int().nonnegative() }),
};
